import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';
import {
  getCupraNextStateIds,
  setCurrentCupraStateId,
  type CupraConversationStateId
} from '@/config/cupra-conversation-states';
import { getCupraRealtimeInstructions } from '@/config/cupra-instructions';
import { toolRegistry } from '@/tools/tool-registry';

const ALL_STATE_IDS: CupraConversationStateId[] = [
  'greeting',
  'needs_discovery',
  'recommendation',
  'explanation',
  'questions_and_closing',
  'farewell'
];

export const stateChangeToolCupraSchema: ToolSchema = {
  type: 'function',
  name: 'set_conversation_state',
  description:
    'Switch the CUPRA conversation state. Call only when current state exit condition is met.',
  parameters: {
    type: 'object',
    properties: {
      next_state: {
        type: 'string',
        enum: ALL_STATE_IDS,
        description: 'Next conversation state id'
      }
    },
    required: ['next_state'],
    additionalProperties: false
  }
};

export const stateChangeToolCupraImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  const nextState = args?.next_state;

  if (!nextState || !ALL_STATE_IDS.includes(nextState)) {
    return { success: false, error: 'Invalid next_state provided.' };
  }

  setCurrentCupraStateId(nextState);
  const allowedNext = getCupraNextStateIds(nextState).join(', ') || 'none';

  return {
    success: true,
    data: `State updated to ${nextState}. Allowed next states: ${allowedNext}.`,
    sessionUpdate: {
      instructions: getCupraRealtimeInstructions(nextState),
      tools: toolRegistry.getToolSchemas()
    }
  };
};

